// import MDXRenderer from "./MdxContent";
import { KitchenSinkToolbar, MDXEditor, codeBlockPlugin, codeMirrorPlugin, diffSourcePlugin, frontmatterPlugin, headingsPlugin, imagePlugin, linkDialogPlugin, linkPlugin, listsPlugin, markdownShortcutPlugin, quotePlugin, sandpackPlugin, tablePlugin, thematicBreakPlugin, toolbarPlugin } from '@mdxeditor/editor';
import '@mdxeditor/editor/style.css';
import '../entrypoints/daisy-prose.css';
import CustomImageDialog from '../pages/Admin/Announcements/CustomImageDialog';
import { useFormContext, Controller } from 'react-hook-form';

function getPlugins(originalContent: string) {
  return ([
    toolbarPlugin({ toolbarContents: () => <KitchenSinkToolbar /> }),
    listsPlugin(),
    quotePlugin(),
    headingsPlugin({ allowedHeadingLevels: [1, 2, 3] }),
    linkPlugin(),
    linkDialogPlugin(),
    imagePlugin({
      ImageDialog: CustomImageDialog,
    }),
    tablePlugin(),
    thematicBreakPlugin(),
    frontmatterPlugin(),
    codeBlockPlugin({ defaultCodeBlockLanguage: '' }),
    // sandpackPlugin({ sandpackConfig: virtuosoSampleSandpackConfig }),
    codeMirrorPlugin({ codeBlockLanguages: { js: 'JavaScript', css: 'CSS', txt: 'Plain Text', tsx: 'TypeScript', '': 'Unspecified' } }),
    // directivesPlugin({ directiveDescriptors: [YoutubeDirectiveDescriptor ] }),
    diffSourcePlugin({ viewMode: 'rich-text', diffMarkdown: originalContent }),
    markdownShortcutPlugin(),
  ])
}

export default function RichMdxEditor({ name = 'content' }: { name?: string }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <div style={{
          height: '100%',
          overflow: 'auto',
        }}>
          <MDXEditor
            markdown={field.value || ''}
            onChange={field.onChange}
            plugins={getPlugins(field.value)}
            autoFocus={true}
            contentEditableClassName="daisy-prose"
          />
        </div>
      )}
    />
  )
}
